import img1 from "../../Assets/IMG_1419.webp"
import img1_300px from "../../Assets/IMG_1419_300x200.webp"
import img1_600px from "../../Assets/IMG_1419_1_600x400.webp"
import img1_900px from "../../Assets/IMG_1419_2_900x600.webp"
import img2 from "../../Assets/IMG_1432.webp"
import img2_300px from "../../Assets/IMG_1432_300x200.webp"
import img2_600px from "../../Assets/IMG_1432_1_600x400.webp"
import img2_900px from "../../Assets/IMG_1432_2_900x600.webp"
import img3 from "../../Assets/IMG_1434.webp"
import img3_300px from "../../Assets/IMG_1434_300x200.webp"
import img3_600px from "../../Assets/IMG_1434_1_600x400.webp"
import img3_900px from "../../Assets/IMG_1434_2_900x600.webp"
import img4 from "../../Assets/000023.webp"
import img4_300px from "../../Assets/000023_300x203.webp"
import img4_600px from "../../Assets/000023_1_600x405.webp"
import img4_900px from "../../Assets/000023_2_900x608.webp"
import img6 from "../../Assets/000032.webp"
import img6_300px from "../../Assets/000032_300x203.webp"
import img6_600px from "../../Assets/000032_1_600x405.webp"
import img6_900px from "../../Assets/000032_2_900x608.webp"
import img7 from "../../Assets/000034.webp"
import img7_300px from "../../Assets/000034_300x444.webp"
import img7_600px from "../../Assets/000034_1_600x888.webp"
import img7_900px from "../../Assets/000034_2_900x1332.webp"
import img8 from "../../Assets/IMG_1407.webp"
import img8_300px from "../../Assets/IMG_1407_300x200.webp"
import img8_600px from "../../Assets/IMG_1407_1_600x400.webp"
import img8_900px from "../../Assets/IMG_1407_2_900x600.webp"
import img9 from "../../Assets/IMG_1415.webp"
import img9_300px from "../../Assets/IMG_1415_300x200.webp"
import img9_600px from "../../Assets/IMG_1415_1_600x400.webp"
import img9_900px from "../../Assets/IMG_1415_2_900x600.webp"
import img10 from "../../Assets/IMG_1421.webp"
import img10_300px from "../../Assets/IMG_1421_1_300x200.webp"
import img10_600px from "../../Assets/IMG_1421_2_600x400.webp"
import img10_900px from "../../Assets/IMG_1421_3_900x600.webp"
import img11 from "../../Assets/IMG_1423.webp"
import img11_300px from "../../Assets/IMG_1423_300x200.webp"
import img11_600px from "../../Assets/IMG_1423_1_600x400.webp"
import img11_900px from "../../Assets/IMG_1423_2_900x600.webp"
import img12 from "../../Assets/IMG_1433.webp"
import img12_300px from "../../Assets/IMG_1433_300x200.webp"
import img12_600px from "../../Assets/IMG_1433_1_600x400.webp"
import img12_900px from "../../Assets/IMG_1433_2_900x600.webp"
import img13 from "../../Assets/IMG_1444.webp"
import img13_300px from "../../Assets/IMG_1444_300x200.webp"
import img13_600px from "../../Assets/IMG_1444_1_600x400.webp"
import img13_900px from "../../Assets/IMG_1444_2_900x600.webp"
import img14 from "../../Assets/IMG_1446.webp"
import img14_300px from "../../Assets/IMG_1446_300x200.webp"
import img14_600px from "../../Assets/IMG_1446_1_600x400.webp"
import img14_900px from "../../Assets/IMG_1446_2_900x600.webp"
import img15 from "../../Assets/IMG_1450.webp"
import img15_300px from "../../Assets/IMG_1450_300x200.webp"
import img15_600px from "../../Assets/IMG_1450_1_600x400.webp"
import img15_900px from "../../Assets/IMG_1450_2_900x600.webp"
import img16 from "../../Assets/IMG_1459.webp"
import img16_300px from "../../Assets/IMG_1459_300x200.webp"
import img16_600px from "../../Assets/IMG_1459_1_600x400.webp"
import img16_900px from "../../Assets/IMG_1459_2_900x600.webp"
import img17 from "../../Assets/1.webp"
import img17_300px from "../../Assets/1_300x200.webp"
import img17_600px from "../../Assets/1_1_600x399.webp"
import img17_900px from "../../Assets/1_2_900x599.webp"
import img18 from "../../Assets/2.webp"
import img18_300px from "../../Assets/2_300x203.webp"
import img18_600px from "../../Assets/2_1_600x405.webp"
import img18_900px from "../../Assets/2_2_900x608.webp"
import img19 from "../../Assets/3.webp"
import img19_300px from "../../Assets/3_300x391.webp"
import img19_600px from "../../Assets/3_1_600x782.webp"
import img19_900px from "../../Assets/3_2_900x1173.webp"
import img20 from "../../Assets/4.webp"
import img20_300px from "../../Assets/4_300x450.webp"
import img20_600px from "../../Assets/4_1_600x900.webp"
import img20_900px from "../../Assets/4_2_900x1350.webp"
import img21 from "../../Assets/img0012.webp"
import img21_300px from "../../Assets/img0012_300x200.webp"
import img21_600px from "../../Assets/img0012_1_600x400.webp"
import img21_900px from "../../Assets/img0012_2_900x600.webp"
import img22 from "../../Assets/img0015.webp"
import img22_300px from "../../Assets/img0015_300x200.webp"
import img22_600px from "../../Assets/img0015_1_600x400.webp"
import img22_900px from "../../Assets/img0015_2_900x600.webp"
import img23 from "../../Assets/img0021.webp"
import img23_300px from "../../Assets/img0021_300x200.webp"
import img23_600px from "../../Assets/img0021_1_600x400.webp"
import img23_900px from "../../Assets/img0021_2_900x600.webp"
import img24 from "../../Assets/000027.webp"
import img24_300px from "../../Assets/000027_300x203.webp"
import img24_600px from "../../Assets/000027_1_600x405.webp"
import img24_900px from "../../Assets/000027_2_900x608.webp"
import img25 from "../../Assets/000028.webp"
import img25_300px from "../../Assets/000028_300x203.webp"
import img25_600px from "../../Assets/000028_1_600x405.webp"
import img25_900px from "../../Assets/000028_2_900x608.webp"
import img26 from "../../Assets/img0022.webp"
import img26_300px from "../../Assets/img0022_300x200.webp"
import img26_600px from "../../Assets/img0022_1_600x400.webp"
import img26_900px from "../../Assets/img0022_2_900x600.webp"
import img27 from "../../Assets/img0023.webp"
import img27_300px from "../../Assets/img0023_300x200.webp"
import img27_600px from "../../Assets/img0023_1_600x400.webp"
import img27_900px from "../../Assets/img0023_2_900x600.webp"
import img28 from "../../Assets/4D7577AF-34AB-455A-AEA2-B10C0C04A0EE_1_105_c.webp"
import img28_300px  from "../../Assets/4D7577AF-34AB-455A-AEA2-B10C0C04A0EE_1_105_c_300x200.webp"
import img28_600px  from "../../Assets/4D7577AF-34AB-455A-AEA2-B10C0C04A0EE_1_105_c_1_600x399.webp"
import img28_900px  from "../../Assets/4D7577AF-34AB-455A-AEA2-B10C0C04A0EE_1_105_c_2_900x599.webp"
import img29 from "../../Assets/000030.webp"
import img29_300px from "../../Assets/000030_3_300x200.webp"
import img29_600px from "../../Assets/000030_4_600x399.webp"
import img29_900px from "../../Assets/000030_5_900x599.webp"
import img30 from "../../Assets/000040.webp"
import img30_300px from "../../Assets/000040_300x200.webp"
import img30_600px from "../../Assets/000040_1_600x399.webp"
import img30_900px from "../../Assets/000040_2_900x599.webp"
import img31 from "../../Assets/000032 copie.webp"
import img31_300px from "../../Assets/000032_copie_300x200.webp"
import img31_600px from "../../Assets/000032_copie_1_600x399.webp"
import img31_900px from "../../Assets/000032_copie_2_900x599.webp"

const Data = [
    {
        id: 1,
        img: img1,
        img_300px: img1_300px,
        img_600px: img1_600px,
        img_900px: img1_900px,
    },
    {
        id: 2,
        img: img2,
        img_300px: img2_300px,
        img_600px: img2_600px,
        img_900px: img2_900px,
    },
    {
        id: 3,
        img: img3,
        img_300px: img3_300px,
        img_600px: img3_600px,
        img_900px: img3_900px,
    },
    {
        id: 4,
        img: img4,
        img_300px: img4_300px,
        img_600px: img4_600px,
        img_900px: img4_900px,
    },
    {
        id: 6,
        img: img6,
        img_300px: img6_300px,
        img_600px: img6_600px,
        img_900px: img6_900px,
    },
    {
        id: 7,
        img: img7,
        img_300px: img7_300px,
        img_600px: img7_600px,
        img_900px: img7_900px,
    },
    {
        id: 8,
        img: img8,
        img_300px: img8_300px,
        img_600px: img8_600px,
        img_900px: img8_900px,

    },
    {
        id: 9,
        img: img9,
        img_300px: img9_300px,
        img_600px: img9_600px,
        img_900px: img9_900px,
    },
    {
        id: 10,
        img: img10,
        img_300px: img10_300px,
        img_600px: img10_600px,
        img_900px: img10_900px,
    },
    {
        id: 11,
        img: img11,
        img_300px: img11_300px,
        img_600px: img11_600px,
        img_900px: img11_900px,
    },
    {
        id: 12,
        img: img12,
        img_300px: img12_300px,
        img_600px: img12_600px,
        img_900px: img12_900px,
    },
    {
        id: 13,
        img: img13,
        img_300px: img13_300px,
        img_600px: img13_600px,
        img_900px: img13_900px,

    },
    {
        id: 14,
        img: img14,
        img_300px: img14_300px,
        img_600px: img14_600px,
        img_900px: img14_900px,
    },
    {
        id: 15,
        img: img15,
        img_300px: img15_300px,
        img_600px: img15_600px,
        img_900px: img15_900px,
    },
    {
        id: 16,
        img: img16, 
        img_300px: img16_300px,
        img_600px: img16_600px,
        img_900px: img16_900px,

    },
    {
        id: 17,
        img: img17,
        img_300px: img17_300px,
        img_600px: img17_600px,
        img_900px: img17_900px,
    },
    {
        id: 18,
        img: img18,
        img_300px: img18_300px,
        img_600px: img18_600px,
        img_900px: img18_900px,
    },
    {
        id: 19,
        img: img19,
        img_300px: img19_300px,
        img_600px: img19_600px,
        img_900px: img19_900px,
    },
    {
        id: 20, 
        img: img20,
        img_300px: img20_300px,
        img_600px: img20_600px,
        img_900px: img20_900px,
    },
    {
        id: 21,
        img: img21,
        img_300px: img21_300px,
        img_600px: img21_600px,
        img_900px: img21_900px,
    },
    {
        id: 22,
        img: img22,
        img_300px: img22_300px,
        img_600px: img22_600px,
        img_900px: img22_900px,
    },
    {
        id: 23,
        img: img23,
        img_300px: img23_300px,
        img_600px: img23_600px,
        img_900px: img23_900px,
    },
    {
        id: 24,
        img: img24,
        img_300px: img24_300px,
        img_600px: img24_600px,
        img_900px: img24_900px,
    },
    {
        id: 25,
        img: img25,
        img_300px: img25_300px,
        img_600px: img25_600px,
        img_900px: img25_900px,
    },
    {
        id: 26,
        img: img26,
        img_300px: img26_300px,
        img_600px: img26_600px,
        img_900px: img26_900px,
    },
    {
        id: 27,
        img: img27,
        img_300px: img27_300px,
        img_600px: img27_600px,
        img_900px: img27_900px,
    },
    {
        id: 28,
        img: img28,
        img_300px: img28_300px,
        img_600px: img28_600px,
        img_900px: img28_900px,
    },
    {
        id: 29,
        img: img29,
        img_300px: img29_300px,
        img_600px: img29_600px,
        img_900px: img29_900px,
    },
    {
        id: 30,
        img: img30,
        img_300px: img30_300px,
        img_600px: img30_600px,
        img_900px: img30_900px,
    },
    {
        id: 31,
        img: img31,
        img_300px: img31_300px,
        img_600px: img31_600px,
        img_900px: img31_900px,
    }, 
]

export default Data;